@if (paginator) {
  <nav>
    <div class="text-center fw-bold mb-3">{{ paginator.count ? paginator.count : 'no' }} result@if (paginator.count > 1) {
      <span
      >s</span>
      }@if (paginator.count) {
      <span> - page {{ paginator.currentPage }}
      / {{ paginator.pageCount }}</span>
    }</div>
    @if (paginator.count) {
      <ul class="pagination justify-content-center">
        @if (getPreviousPage()) {
          <li class="page-item">
            <a class="page-link" href (click)="changePage($event, getFirstPage())" aria-label="First">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
        }
        @if (getPreviousPage()) {
          <li class="page-item">
            <a class="page-link" href (click)="changePage($event, getPreviousPage())"  aria-label="Previous">
              <span aria-hidden="true">&lsaquo;</span>
            </a>
          </li>
        }
        @for (page of getPages(); track page) {
          <li class="page-item" [ngClass]="{active:isCurrentPage(page)}">
            <a class="page-link" href (click)="changePage($event, page)">{{ page }}</a>
          </li>
        }
        @if (getNextPage()) {
          <li class="page-item">
            <a class="page-link" href (click)="changePage($event, getNextPage())" aria-label="Next">
              <span aria-hidden="true">&rsaquo;</span>
            </a>
          </li>
        }
        @if (getNextPage()) {
          <li class="page-item">
            <a class="page-link" href (click)="changePage($event, getLastPage())" aria-label="Last">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        }
      </ul>
    }
  </nav>
}
